import React, { useContext, useEffect, useState } from "react";
import SvgMore from "../../../icons/SvgMore";
import eye from "../../../assets/eye.svg";
import share from "../../../assets/bx-share.svg";
import trash from "../../../assets/red-trash.svg";
import Calendar from "../../../assets/calendar.svg";
import { useNavigate, useParams } from "react-router-dom";
import { AppContext } from "../../../context";
import SvgPen2 from "../../../icons/SvgPen2";
import dayjs from "dayjs";
import { getDateTimeDate } from "../../../utils/timeHelpers";
import { formatCurrency } from "../../../services/Utils";
import CohortDetailsPreview from "../CohortDetailsPreview";
import ShareUrl from "../../ShareUrl";
import { useSelector } from "react-redux";
import { DeleteCohort } from "../../../services/cohortService";
import { Modal, notification } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { cancelButtonProps, okButtonProps } from "../../menu/constant";

function CohortCard({
  className,
  cohort,
  index,
  outsideDashboard,
  isDraft,
  refreshList,
  isPast,
}) {
  const qalortUser = useSelector((state) => state.user.userData);
  const [cohortDetails, setCohortDetails] = useState(null);
  const [moreDropdwon, setMoreDropdown] = useState(null);
  const [shareModalVisible, setShareModalVisible] = useState(false);
  const navigate = useNavigate();
  const { updateContext } = useContext(AppContext);
  const { cohort_id } = useParams();
  const { confirm } = Modal;

  const toggleDropdown = (index) => {
    setMoreDropdown((prevIndex) => (prevIndex === index ? null : index));
  };

  const editCohort = (cohort) => {
    updateContext(cohort);
    navigate(`/cohort/create-cohort?cohort_id=${cohort?.slug}`);
  };

  useEffect(() => {
    if (cohort_id === cohort?.id) {
      setCohortDetails(cohort);
    }
  }, [cohort_id, cohort]);

  const openDraft = () => {
    updateContext({ ...cohort });
    let data = {
      ...cohort,
      capacity: cohort.capacity,
      requirements: cohort?.requirements?.map((t) => t.content),
      audiences: cohort?.audiences?.map((t) => t.audience),
      topics: cohort?.topics?.map((t) => t.topic),
    };
    if (dayjs(cohort?.start_date).isBefore(dayjs())) {
      data.start_date = "";
    }
    if (dayjs(cohort?.end_date).isBefore(dayjs())) {
      data.end_date = "";
    }

    updateContext(data);
    navigate("/cohort/create-cohort?from=draft");
  };

  const deleteCohortHandler = async () => {
    try {
      await DeleteCohort(cohort?.id, isDraft);
      notification.success({
        message: isDraft
          ? "Draft deleted successfully"
          : "Cohort deleted successfully",
      });
      refreshList?.();
    } catch (error) {
      console.log(error);

      notification.error({
        message: "Error deleting cohort",
      });
    }
  };

  const linkPath = isDraft ? "" : `/cohort/messages/${cohort?.slug}`;
  return (
    <>
      <div
        className={`bg-white rounded-lg border border-neutral w-full md:w-[270px] ${className}`}
      >
        <div className="relative">
          <div className="flex justify-between items-center w-full absolute top-3.5 left-0 right-0 pl-3.5 pr-[11px]">
            <div className="bg-pri rounded-[14px] py-2 px-3 shadow-[0_4px_30px_0_#06061105]">
              {cohort?.price > 0 ? (
                <p className="p-2xs text-white !font-medium mb-0 !leading-3">
                  {`${cohort.currency}${formatCurrency(cohort?.price / 100)}`}
                </p>
              ) : (
                <p className="p-2xs text-white !font-medium mb-0 !leading-3">
                  Free
                </p>
              )}
            </div>
            <div
              className="relative"
              onMouseLeave={() => setMoreDropdown(null)}
            >
              <button
                className="cursor-pointer bg-white flex items-center justify-center rounded-full w-[25px] h-[25px]"
                onClick={() => toggleDropdown(index)}
              >
                <SvgMore className="text-[#30307D] w-4 h-4" />
              </button>

              {moreDropdwon === index && (
                <div className="absolute top-6 right-0 bg-white rounded-lg flex flex-col w-[176px] z-50 shadow-6 border border-grey-2 py-2 px-2">
                  {isPast ? null : cohort?.user_id === qalortUser?.id ||
                    isDraft ? (
                    <button
                      className="flex items-end gap-2 py-[7px] px-2 hover:bg-[#EFEFFE] rounded-[12px]"
                      onClick={() => {
                        isDraft ? openDraft() : editCohort(cohort);
                      }}
                    >
                      <SvgPen2 currentColor={"#7575a9"} />
                      <p className="p-xs text-tint font-medium mb-0">Edit</p>
                    </button>
                  ) : null}

                  {!isDraft && (
                    <>
                      {!isPast && (
                        <button
                          className="flex items-end gap-2 py-[7px] px-2 hover:bg-[#EFEFFE] rounded-[12px]"
                          onClick={() => {
                            setShareModalVisible(true);
                            setMoreDropdown(false);
                          }}
                        >
                          <div className="">
                            <img src={share} alt="" />
                          </div>
                          <p className="p-xs text-tint font-medium mb-0">
                            Share
                          </p>
                        </button>
                      )}
                      <button
                        className="flex items-end gap-2 py-[7px] px-2 hover:bg-[#EFEFFE] rounded-[12px]"
                        onClick={() => {
                          navigate(`/ct/${cohort?.slug}`);
                        }}
                      >
                        <div className="">
                          <img src={eye} alt="" />
                        </div>
                        <p className="p-xs text-tint font-medium mb-0">
                          Preview
                        </p>
                      </button>
                    </>
                  )}

                  {(cohort?.user_id === qalortUser?.id || isDraft) && (
                    <button
                      className="flex items-end gap-2 py-[7px] px-2 hover:bg-[#EFEFFE] rounded-[12px] red"
                      onClick={() => {
                        confirm({
                          title: "Confirm",
                          icon: <ExclamationCircleOutlined />,
                          content:
                            "Are you sure you want to delete this cohort?",
                          okText: "Proceed",
                          cancelText: "Cancel",
                          onOk: () => {
                            deleteCohortHandler();
                          },
                          okButtonProps: {
                            className: okButtonProps,
                          },
                          cancelButtonProps: {
                            className: cancelButtonProps,
                          },
                        });
                      }}
                    >
                      <div className="">
                        <img src={trash} alt="" />
                      </div>
                      <p className="p-xs font-medium mb-0">Archive</p>
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
          {/* <Link key={index} to={linkPath}> */}
          <div
            onClick={() => {
              isDraft
                ? openDraft()
                : outsideDashboard
                ? navigate(`/ct/${cohort?.slug}`)
                : navigate(linkPath);
            }}
            className="w-full h-[170px] overflow-hidden rounded-t-lg flex justify-center items-center cursor-pointer bg-[#000000]"
          >
            <img src={cohort?.banner} alt="" className="w-[120%] h-auto" />
          </div>
          {/* </Link> */}
        </div>
        {/* <Link key={index} to={linkPath}> */}
        <div
          onClick={() => {
            isDraft
              ? openDraft()
              : outsideDashboard
              ? navigate(`/ct/${cohort?.slug}`)
              : navigate(linkPath);
          }}
          className="py-[10.5px] px-2.5 flex flex-col h-[calc(100%-170px)] cursor-pointer"
        >
          <div className="flex flex-col gap-2 ">
            {cohort?.category && (
              <div className="bg-[#5F5FFA1A] px-2 py-1 rounded-[12px] pri w-fit font-semibold text-[12px]">
                {cohort?.category}
              </div>
            )}
            <p className="p-sm leading-5 font-semibold text-main mb-1.5">
              {cohort?.title}
            </p>
            <p className="text-[13px] leading-5 text-tint w-full font-medium mb-2.5 overflow-hidden">
              {cohort?.description?.slice(0, 40)}...
            </p>
          </div>
          {cohort?.start_date && (
            <div className="flex justify-between mt-auto">
              <p className="font-medium mb-0 pri text-[12px] flex gap-1.5">
                <img src={Calendar} alt="" />
                {dayjs(getDateTimeDate(cohort?.start_date)).format(
                  "MMM D, YYYY"
                )}
              </p>
            </div>
          )}
        </div>
        {/* </Link> */}
      </div>
      <ShareUrl
        title="Cohort"
        visible={shareModalVisible}
        onCancel={() => setShareModalVisible(false)}
        setShareModalVisible={setShareModalVisible}
        url={`${window?.location.origin}/ct/${cohort?.slug}`}
        cohortName={cohort?.title}
      />
      {!!cohortDetails && (
        <CohortDetailsPreview
          isOpen={!!cohortDetails}
          onClose={() => {
            setCohortDetails(null);
            outsideDashboard ? navigate(null) : navigate("/cohort");
          }}
          slug={cohort?.slug}
          outsideDashboard={outsideDashboard}
        />
      )}
    </>
  );
}

export default CohortCard;
